module.exports = __webpack_public_path__ + "static/media/tick-save.62c52e35.svg";